<template>
    <div id="header-container">
        <div class="header-left">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                :ellipsis="false">
                <el-menu-item index="1">
                    <router-link to="/">首页</router-link>
                </el-menu-item>
                <el-menu-item index="2">
                    <router-link to="/new">新作</router-link>
                </el-menu-item>
                <el-menu-item index="3">
                    <router-link :to="{name:'rank', query:{type:0, date:this.newDate}}">榜单</router-link>
                </el-menu-item>
            </el-menu>
        </div>
        <div class="header-center">
            <div class="mt-4">
                <el-input v-model="input1" style="max-width: 600px" placeholder="Please input"
                    class="input-with-select" @keyup.enter.native="searchByTag">
                    <template #prepend>
                        <el-button :icon="Search" />
                    </template>
                    <template #append>
                        <el-select v-model="select" placeholder="Select" style="width: 115px">
                            <el-option label="按标签" value="1" />
                            <el-option label="按画师" value="2" />
                        </el-select>
                    </template>
                </el-input>
            </div>
        </div>
        <div class="header-right">
            <div style="width: 75px;">
                <a href="#">交流</a>
            </div>
            <el-button type="primary" round>Primary</el-button>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { Search } from '@element-plus/icons-vue'

export default {
    name: 'Navigation',
    data() {
        return {
            activeIndex: ref('1'),
            activeIndex2: ref('1'),
            input1: ref(''),
            select: ref('1'),
            Search: Search,
        }
    },
    methods: {
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        },
        searchByTag() {
            if (this.select == 1) {
                this.$router.push({name:'search', query:{tag:this.input1}});
            }
            else if (this.select == 2) {
                this.$router.push({name:'searchAuthor', query:{keyword:'藤原'}});
            }
        },

        nowDay() {
            const now = new Date();

            const year = now.getFullYear();
            const month = ('0' + (now.getMonth() + 1)).slice(-2);
            const day = ('0' + now.getDate(now.setDate(now.getDate() -1))).slice(-2);
            const formattedTime = year + "-" + month + "-" + day;
            return [formattedTime, month];
        },
    },
    created() {
        [this.newDate, this.newMonth] = this.nowDay();
    },
}
</script>

<style scoped>
a {
    text-decoration: none;
    outline: 0;
}

#header-container {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    /* grid-template-columns: 1fr minmax(0, 528px) 1fr; */
    grid-gap: 24px;
    width: 100%;
    min-width: 635px;
    height: 64px;
    padding: 0 24px;
    background-color: rgb(255, 255, 255);
}

.header-left,
.header-center,
.header-right {
    display: flex;
    align-items: center;
    width: 30%;
    justify-content: space-evenly;
}

.input-with-select .el-input-group__prepend {
    background-color: var(--el-fill-color-blank);
}
</style>